import CopaLogo from '../../../assets/logo-copa.svg?react'
import { cn } from '../../../enviroment/lib/utils'

interface AssistantMessageWrapperProps {
  children: React.ReactNode
  transparent?: boolean
  hideIcon?: boolean
  wide?: boolean
}

const AssistantMessageWrapper: React.FC<AssistantMessageWrapperProps> = ({ children, transparent, hideIcon, wide }) => (
  <div className={cn('flex flex-col items-start gap-2')}>
    {!hideIcon && <CopaLogo width={24} height={24} />}

    <div
      className={cn(
        'w-full',
        transparent
          ? 'text-gray-100'
          : cn(
              !wide && 'max-w-80',
              'rounded-bl-[16px] rounded-br-[16px] rounded-tl-[4px] rounded-tr-[16px]',
              'bg-gray-800 text-gray-100',
            ),
      )}
    >
      {children}
    </div>
  </div>
)
export default AssistantMessageWrapper
